import {observer} from "mobx-react";
import * as React from "react";
import {action, observable} from "mobx";
import {QuizQuestion} from "components/quiz/QuizQuestion";
import {UserAnswer} from "components/quiz/UserAnswer";

class Answer {
  label:string;
  value:string;
  @observable checked:boolean;
}

interface ICheckboxQuestion_Props {
  userAnswer:UserAnswer;
}

@observer
export class CheckboxQuestion extends React.Component<ICheckboxQuestion_Props> {
  @observable answers:Answer[] = [];

  constructor(props:ICheckboxQuestion_Props) {
    super(props);
    const possibleAnswers:Answer[] = [];
    props.userAnswer.step.answers.forEach((answer)=>{
      const idx = props.userAnswer.answerValue ? props.userAnswer.answerValue.findIndex(av=>av===answer.label) : -1;
      possibleAnswers.push({
        label:answer.label,
        value:answer.value,
        checked:idx>-1,
      });
    });
    this.answers = possibleAnswers;
  }

  @action handleAnswerUpdate = () => {
    const checkedValues: string[] = [];
    this.answers.forEach((answer) => {
      if (answer.checked) {
        checkedValues.push(answer.label);
      }
    });
    this.props.userAnswer.answerValue = checkedValues.length>0?checkedValues:'';
  }

  render() {
    const {userAnswer} = this.props;
    return (
      <QuizQuestion>
        {this.answers.map((answer:any, idx)=><Checkbox answer={answer} key={idx} onClick={this.handleAnswerUpdate} />)}
      </QuizQuestion>
    );
  }
}

interface ICheckbox_Props {
  answer:Answer;
  onClick:()=>void;
}

@observer
class Checkbox extends React.Component<ICheckbox_Props> {
  handleClick = () => {
    this.props.answer.checked = !this.props.answer.checked;
    this.props.onClick();
  }
  render() {
    const squareStyle = this.props.answer.checked ? {background:'#7ED321'} : {};
    return (
      <div className={"option"}>
        <span style={{position: 'relative'}} onClick={this.handleClick}>
          <div className="error"></div>
          <div className="square" style={squareStyle}></div>
          <div className="question" style={{}}>{this.props.answer.label}</div>
        </span>
      </div>
    );
  }
}


;


